import Vue from 'vue'

Vue.filter('carNameDisplay', (name, brand) => {
  let value = ''
  if (brand) {
    value = value + '(' + brand + ') '
  }
  if (name) {
    value = value + name
  }
  return value
})

Vue.filter('comma', (value) => {
  if(value)
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  else
    return 0
})

Vue.filter('commaNew', (value) => {
  if(value < 0 || value > 100000)
    return 0
  else if(!value)
    return 0
  else
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

Vue.filter('timeToMin', (value) => {
  let format = /^[0-9]{2}:[0-9]{2}:[0-9]{2}$/
  if (!value)
    return value
  if (value.search(format) === -1)
    return value

  let t = value.split(':')
  // return t[0]+'시간'+t[1]+'분'+t[2]+'초'
  if (parseInt(t[0])) {
    return parseInt(t[0]) + '시간' + parseInt(t[1]) + '분'
  } else {
    return parseInt(t[1]) + '분'
  }
})

